export default class Test {
	constructor(app) {
		this.app = app;
	}
	message(message) {
		this.app.showToast(message);
	}
	awardAchievement() {
		const achievement = this.app.achievements.allAchievements[5];
		this.app.achievements.awardAchivement({}, "Win Insane Monkey Under 35 Seconds");
		//Win Insane Monkey Under 35 Seconds
	}
	toast() {
		this.message("Test Toast");
	}
	showAd() {
		this.app.showAd(true);
	}
	showAppOpenAd() {
		this.app.showAppOpenAd(true);
	}
	showRewardedAd() {
		this.app.showRewardedAd(true);
	}
	showAppOpenAdWithMaxDelay(){
		this.app.advertisement.showAppOpenAdWithMaxDelay(4000);
	}
	enableAds() {
		this.app.userdata.removeAds = false;
		this.message("userdata.removeAds = false;");
	}
	removeAds() {
		this.app.userdata.removeAds = true;
		this.message("userdata.removeAds = true;");
	}
	enableFullVersion() {
		this.app.userdata.fullVersion = true;
		this.message("userdata.fullVersion = true;");
	}
	removeFullVersion() {
		this.app.userdata.fullVersion = false;
		this.message("userdata.fullVersion = false;");
	}

	rate() {
		this.app.rate();
	}
	rateNative() {
		this.app.rateApp.rateNative();
	}
	delayedPrompt() {
		this.app.prompter.delayedPrompt(25);
	}
	showEnjoyGame() {
		this.app.showEnjoyGame("Are you enjoying the Game?");
	}
	showSharePopup() {
		this.app.showSharePopup();
	}
	showInvite() {
		let invite = {
			name: "Batman",
			userId: -1,
			avatar: 'images/Avatars/vv/AvatarVV_0006.png',
			room: 'test',
			message: "Batman has invited you to play a round!",
			server: null
		};
		this.app.showInvitePopup(invite);
	}
	requestTrackingAuthorizationWithExplainer() {
		this.app.requestTrackingAuthorizationWithExplainer(true);
	}
	requestTrackingAuthorization() {
		this.app.requestTrackingAuthorization();
	}
	RegisterNotification(){
		this.app.pushNotification.RegisterNotification();
	}
	requestNotificationAuthorizationWithExplainer(){
		this.app.requestNotificationAuthorizationWithExplainer(true);
	}
	sendInvite(id){
		this.app.controllers['FindPlayer'].invitePlayer(id,null,true)
	}
	saveServer(){
		const userdata = this.app.userdata;
		this.app.saveServer(userdata,true);
	}
	
}
